import { render } from "./NotFound.vue?vue&type=template&id=5c10f356&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=5c10f356&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c10f356"]])

export default __exports__